export default (props, vars) =>
  !vars?.['useapplicationoffer2']?.['isLoading'] &&
  vars?.['useapplicationoffer2']?.['applicationOffer']?.stage_id ===
    vars?.['useapplicationoffer2']?.['applicationOffer'].STAGES
      .STUDENT_DECLINED;
